var $5ab25ba52a4fc5fe$exports = {};
$5ab25ba52a4fc5fe$exports = {
    "removeButtonLabel": `No\u{146}emt`,
    "removeDescription": `Nospiediet Delete [Dz\u{113}st], lai no\u{146}emtu tagu.`
};


export {$5ab25ba52a4fc5fe$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
